import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-inline" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-power-off",
  style: {}
}, null, -1)
const _hoisted_3 = {
  style: {"font-size":"90%","margin-left":"20px"},
  class: "d-inline"
}



export default /*#__PURE__*/_defineComponent({
  __name: 'CloseSesionView',
  props: {
 version: String
},
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "footermnuWebBurger",
    onClick: _cache[0] || (_cache[0] = ($event: any) => { emit('onClose',true);})
  }, [
    _createElementVNode("h5", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('globals.closesesion')), 1)
    ]),
    _createElementVNode("span", _hoisted_3, " (" + _toDisplayString(__props.version) + ") ", 1)
  ]))
}
}

})